import React, { Component }from 'react'
import { connect } from 'react-redux'
import { Row, Col, Glyphicon, FormControl, FormGroup, InputGroup, Button, Table } from 'react-bootstrap'

import { getProjectsWithFilters } from '../reducers/manageProjects'
import { changeProjectPage, inputProjectName, toggleProjectsHaveBeenSearched } from '../reducers/manageProjectFilters'

import PaginationButtons from '../../../reuseable-components/PaginationButtons'

import ProjectListItem from './ProjectListItem'

class ProjectView extends Component {

  componentDidMount() {
    const searchBar = document.getElementById('projectSearchTermInput')

    if (searchBar) {
      searchBar.addEventListener("search", this.handleSearchBarClear)
    }

    if (this.props.projectNameFilter) {
      this.props.toggleProjectsHaveBeenSearched(true)
    } else {
      this.props.toggleProjectsHaveBeenSearched(false)
    }
  }

  componentWillUnmount() {
    const searchBar = document.getElementById('projectSearchTermInput')

    if (searchBar) {
      searchBar.removeEventListener("search", this.handleSearchBarClear)
    }
  }

  handleSearchBarClear = (event) => {
    const { projectsHaveBeenSearched } = this.props
    if (event.type && event.type === 'search' && projectsHaveBeenSearched) {
      this.props.toggleProjectsHaveBeenSearched(false)
      this.props.handleGetProjects(1)
    }
  }

  handleSearch = () => {
    this.props.toggleProjectsHaveBeenSearched(true)
    this.props.handleGetProjects(1)
  }


  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      this.handleSearch()
    }
  }


  render () {

    const {
      projects,
      fetchingProjects,
      projectCount,
      projectResultsPerPage,
      currentProjectPage,
      projectNameFilter,
    } = this.props

    // THIS WILL SHOW THE NUMBER OF PAGES FOR THE PAGINATION BUTTONS
    let numberOfPages
    if (projects && projects.length > 0) {
      numberOfPages = Math.ceil(projectCount / projectResultsPerPage)
    }

    return (
      <div id="ProjectView">
        <Row>
          <Col md={6}>
            <div style={{ marginTop: "15px" }}>
              <FormGroup>
                <InputGroup>
                  <FormControl
                    id='projectSearchTermInput'
                    type="search"
                    value={projectNameFilter}
                    placeholder="Enter project name, short code, or number"
                    onChange={(e) => this.props.inputProjectName(e.target.value)}
                    onKeyDown={this.handleEnterPress}
                  />
                  <InputGroup.Button>
                    <Button
                      bsStyle={projectNameFilter ? "info" : "default"}
                      onClick={this.handleSearch}
                    >
                      <Glyphicon glyph="search" />
                    </Button>
                  </InputGroup.Button>
                </InputGroup>
              </FormGroup>
            </div>
          </Col>

          {numberOfPages && numberOfPages > 1 ?
            <Col md={6}>
              <center style={{fontSize:"8pt"}}>
                <PaginationButtons style={{ display: "inline-block" }}
                  numberOfPages={numberOfPages}
                  currentPage={currentProjectPage}
                  buttonsPerPage={5}
                  onClick={this.props.handleGetProjects}
                />
              </center>
            </Col>
            :
            null
          }
        </Row>

        {!fetchingProjects && projects && projects.length === 0 ?
          <center>
            <br/>
            <h3>No Projects to display</h3>
          </center>
          :
          <Table>
            <thead>
              <tr>
                <td className="project-client">Client</td>
                <td className="project-short-id">Short ID</td>
                <td className="project-title">Title</td>
                <td className="project-status">Status</td>
              </tr>
            </thead>
            <tbody style={{border:"solid thin #F5F6F6", overflow:"scroll", height:"50%"}}>
              {this.props.projects.map(project => {
                return (
                  <ProjectListItem
                    key={project.id}
                    project={project}
                    handleClick={() => this.props.history.push(`/projects/${project.id}`)}
                  />
                )
              })}
            </tbody>
          </Table>
          }

          {numberOfPages && numberOfPages > 1 ?
            <center style={{fontSize:"8pt"}}>
              <PaginationButtons style={{ display: "inline-block" }}
                numberOfPages={numberOfPages}
                currentPage={currentProjectPage}
                buttonsPerPage={5}
                onClick={this.props.handleGetProjects}
              />
            </center>
            :
            null
          }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    fetchingProjects: state.manageProjects.fetchingProjects,
    fetchingDeliverables: state.manageProjects.fetchingDeliverables,
    projects: state.manageProjects.projects,
    nextPage: state.manageProjects.nextPage,
    previousPage: state.manageProjects.previousPage,
    projectCount: state.manageProjects.projectCount,
    projectResultsPerPage: state.manageProjects.projectResultsPerPage,
    projectLeadFilter: state.manageProjectFilters.projectLeads,
    analystFilter: state.manageProjectFilters.analysts,
    projectNameFilter: state.manageProjectFilters.projectName,
    statusFilter: state.manageProjectFilters.status,
    metadataFilters: state.manageProjectFilters.metadataFilters,
    currentProjectPage: state.manageProjectFilters.currentProjectPage,
    currentDeliverablesPage: state.manageProjectFilters.currentDeliverablesPage,
    projectsPerPage: state.manageProjectFilters.projectsPerPage,
    currentUser: state.manageLogin.user,
    projectSortType: state.manageProjectFilters.projectSortType,
    clientFilter: state.manageProjectFilters.clients,
    myProjectsFilter: state.manageProjectFilters.myProjectsFilter,
    projectsHaveBeenSearched: state.manageProjectFilters.projectsHaveBeenSearched,
    clients: state.manageLogin.clients,
    users: state.manageLogin.users,
  }
}

export default connect(mapStateToProps, { getProjectsWithFilters, changeProjectPage, inputProjectName, toggleProjectsHaveBeenSearched })(ProjectView);



// WEBPACK FOOTER //
// ./src/routes/projects/components/ProjectView.js